import { makeStyles } from '@material-ui/core';

const styles = makeStyles((theme) => ({
  list: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 4,
  },
  entry: {
    display: 'flex',
    flexDirection: 'column',
    borderLeft: '3px solid',
    paddingLeft: 8,
    paddingTop: 4,
    paddingBottom: 4,
    marginBottom: 6,
  },
  entryTop: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  action: {
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 0.3,
  },
  when: {
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginLeft: 8,
  },
  who: {
    overflowWrap: 'anywhere',
  },
  meta: {
    color: theme.palette.text.secondary,
    overflowWrap: 'anywhere',
  },
  status: {
    color: theme.palette.text.secondary,
    display: 'block',
    padding: '8px 0',
  },
  statusError: {
    color: theme.palette.error.main,
    display: 'block',
    padding: '8px 0',
  },
  spinner: {
    display: 'flex',
    justifyContent: 'center',
    padding: 8,
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: 4,
  },
  refresh: {
    textTransform: 'none',
    padding: 0,
    minWidth: 0,
    border: 'none',
    fontWeight: 'normal',
  },
  note: {
    color: theme.palette.text.secondary,
    display: 'block',
    marginTop: 6,
  },
}));

export default styles;
